import React, {useContext, useState} from 'react';
import {DebugDeleteProviderRequest, DebugDeleteProviderResponse} from "../../../../provider_api";
import {ProviderProfileContext} from "../../../../ProviderProfileProvider";
import {useRpcSender} from "../../../../util/RpcSender";

import {useNavigateWithParams} from "../../../../util/NavUtils";
import {useSettingsTabs} from "./SettingsRouter";
import {TabbedPageHeader} from "../../../../components/TabbedPageHeader";

export const DebugSettings = () => {

  const {setBusiness, setProvider, setBusinessProfile} = useContext(ProviderProfileContext);
  const rpcSender = useRpcSender();
  const [error, setError] = useState<string>()
  const [autoApproveNewProfile, setAutoApproveNewProfile] = useState(false);
  const navigate = useNavigateWithParams();

  const deleteRpc = (request: DebugDeleteProviderRequest) => {

    rpcSender.send('debug_delete_provider', DebugDeleteProviderRequest.encode(request).finish())
        .then(value => {
          let response = DebugDeleteProviderResponse.decode(value);
          if (response.okay) {
            setProvider(response.provider);
            setBusiness(response.business);
            setBusinessProfile(response.businessProfile);
            navigate('/');
          } else {
            setError("Rpc response not okay")
          }

        })
        .catch(e => {
          console.log(e);
          setError(e)
        });
  }


  return <div className={'NonScrollingToolPage'}>

    <TabbedPageHeader pageTitle={'Settings'} tabs={useSettingsTabs()}/>
    
    <div className={'ProviderToolAreaContent'}>

      <div className={'VerticalFlex Gap20'}>


        <div className={'HorizontalFlex'}>
          <button onClick={() => deleteRpc(new DebugDeleteProviderRequest({
            resetProvider: true
          }))}>
            Reset your provider profile
          </button>
          You'll have to set your name, contact email, and phone.
        </div>

        <div className={'HorizontalFlex'}>
          <button onClick={() => deleteRpc(new DebugDeleteProviderRequest({
            resetBusiness: true,
            autoApproveBusiness: autoApproveNewProfile
          }))}>
            Reset your business
          </button>

          <div className={'VerticalFlex'}>
            You'll go through the new business survey and initial setup.
            <br/>

            <div className={'HorizontalFlex'}>
              <span>Auto-approve new business?</span>
              <input type={'checkbox'} checked={autoApproveNewProfile}
                     onChange={event => setAutoApproveNewProfile(event.target.checked)}/>
            </div>
          </div>
        </div>


        <div className={'HorizontalFlex'}>
          <button onClick={() => deleteRpc(new DebugDeleteProviderRequest({
            deleteProvider: true
          }))}>
            Delete your provider
          </button>
          Your business will stay, but you need a new team member invite.
        </div>

        <div className={'HorizontalFlex'}>
          <button onClick={() => deleteRpc(new DebugDeleteProviderRequest({
            deleteBusinessAndAllProviders: true
          }))}>Delete the business and all providers
          </button>
          You'll need a new business invite.
        </div>

        {error && <div style={{color: 'var(--red)'}}>{error}</div>}

      </div>
    </div>

  </div>;
}